export function createStateMetaMap<
  TValue extends string | number,
  TCode extends string,
>(options: StateOption<TValue, TCode>[]): Partial<Record<TCode, StateMeta>> {
  return options.reduce<Partial<Record<TCode, StateMeta>>>((metaMap, option) => {
    metaMap[option.code] = {
      label: option.label,
      color: option.color,
      bgLight: option.bgLight,
      border: option.border,
      darkColor: option.darkColor,
      bgDark: option.bgDark,
      borderDark: option.borderDark,
    };
    return metaMap;
  }, {});
}
